import { combineReducers } from 'redux';
import { GET_CAMPUS_GROUPS, SAVE_CAMPUS_GROUP, DELETE_CAMPUS_GROUP } from './CampusGroups.actions';
import { ASYNC_FINISH } from '../../../common';

// Org campus-group map keyed by groupId. Loaded lazily (only for flagged
// district admins) and maintained immutably on save/delete so the A-F school
// picker sees changes through a new reference.
const groups = (state = null, action) => {
  switch (action.type) {
    case ASYNC_FINISH:
      if (action.model === GET_CAMPUS_GROUPS) {
        return (action.data && action.data.groups) || {};
      }
      if (action.model === SAVE_CAMPUS_GROUP && action.data && action.data.groupId) {
        return { ...(state || {}), [action.data.groupId]: action.data.group };
      }
      if (action.model === DELETE_CAMPUS_GROUP && action.data && action.data.groupId) {
        const next = { ...(state || {}) };
        delete next[action.data.groupId];
        return next;
      }
      return state;
    default:
      return state;
  }
};

const savedGroup = (state = {}, action) => {
  switch (action.type) {
    case ASYNC_FINISH:
      if (action.model === SAVE_CAMPUS_GROUP) {
        return action.data;
      }
      return state;
    default:
      return state;
  }
};

export const _reducer = combineReducers({
  groups,
  savedGroup,
});

export default 'CampusGroups.reducers.js';
